import {client} from "graphql/client";
import {gql} from "@apollo/client";

export const GET_ACCOUNT_DSP_MANAGER_BY_ACCOUNT_ID = gql`
    query GetAccountDspManagerByAccountId($accountId: Long!) {
        getAccountDspManagerByAccountId(accountId: $accountId) {
            id
            accountId
            dspId
        }
    }
`;

export interface AccountDspManagerType {
    id: number;
    accountId: number;
    dspId: number;
}

export interface GetAccountDspManagerByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountDspManagerByAccountIdQuery {
    getAccountDspManagerByAccountId: AccountDspManagerType;
}

export const getAccountDspManagerByAccountId = async (accountId: number): Promise<AccountDspManagerType> => {
    const {data} = await client.query<GetAccountDspManagerByAccountIdQuery, GetAccountDspManagerByAccountIdQueryVariables>({
        query: GET_ACCOUNT_DSP_MANAGER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountDspManagerByAccountId;
};